import { Routes } from '@angular/router';
import { FeatureShellContainerComponent } from '../components/shell-container/shell-container.component';
import { loadRemoteModule } from '@nx/angular/mf';
import { AdminRoleGuard } from '../guards/admin-role-guard';
import { UsersManagementFeatureFlagGuard } from '../guards/users-management.guard';
import { CustomFieldFeatureFlagGuard } from '../guards/custom-field-list.guard';
import { ROUTES_PATH } from '@rx-applications/clientsite/admin/utils';
import { CompanyPaymentGuard } from '../guards/company-payment.guard';
import { CompanyPaymentResolver } from '../guards/company-payment.resolver';

export const ADMIN_ROUTES: Routes = [
  {
    path: '', // Base path for all admin routes
    component: FeatureShellContainerComponent, // Shell container with navigation
    children: [
      {
        path: ROUTES_PATH.USERS,
        loadComponent: () =>
          import('@rx-applications/clientsite/admin/users/feature-users-table').then((m) => m.FeatureUsersTableComponent),
        canMatch: [AdminRoleGuard, UsersManagementFeatureFlagGuard],
      },
      {
        path: ROUTES_PATH.CUSTOM_FIELDS,
        pathMatch: 'full',
        loadComponent: () =>
          import('@rx-applications/clientsite/admin/custom-fields/feature-custom-fields-list').then(
            (m) => m.FeatureCustomFieldsListComponent,
          ),
        canMatch: [AdminRoleGuard, CustomFieldFeatureFlagGuard],
      },
      {
        path: ROUTES_PATH.CUSTOM_FIELDS + '/:id/edit',
        loadComponent: () =>
          import('@rx-applications/clientsite/admin/custom-fields/feature-custom-field-edit').then(
            (m) => m.FeatureCustomFieldEditComponent,
          ),
        canMatch: [AdminRoleGuard, CustomFieldFeatureFlagGuard],
      },
      {
        path: ROUTES_PATH.PAYMENT,
        loadComponent: () => import('@rx-applications/company-payment/feature-company-payment').then((m) => m.FeatureCompanyPaymentComponent),
        resolve: { websiteData: CompanyPaymentResolver },
        canMatch: [CompanyPaymentGuard],
      },
      { path: '**', redirectTo: ROUTES_PATH.USERS },
    ],
  },
];
